import {countryCodeEmoji} from 'country-code-emoji'
import countries from 'world-countries';

export const COUNTRIES = countries
    .map(country => ({
        code: country.cca3, // Alpha-3 code
        name: country.name.common,
        flag: countryCodeEmoji(country.cca2)
    }))
    .filter(country => country.flag)
    .sort((a, b) => a.name.localeCompare(b.name));